@if (control) {
  <mat-form-field
    appearance="outline"
    class="example-full-width ui-text-area-field ui-form-field-v2"
    subscriptSizing="fixed"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <textarea
      #textarea
      matInput
      [attr.aria-label]="label || placeholder"
      [formControl]="control"
      [errorStateMatcher]="errorStateMatcher"
      [placeholder]="placeholder || label"
      [required]="required"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="8"
    ></textarea>
    @if (description) {
      <mat-hint>{{ description }}</mat-hint>
    }
    @let errorText = control.errors | joinErrorMessages: messages;
    <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
  </mat-form-field>
}
